import React from 'react';

import { isEmpty } from 'lodash';

import cn from '~/utils/cn';

export interface DocumentSelectionSummaryProps {
  selectedDocuments: unknown[];
  className?: string;
}

const DocumentSelectionSummary: React.FC<DocumentSelectionSummaryProps> = ({ selectedDocuments, className = '' }) => {
  const summaryText = isEmpty(selectedDocuments)
    ? 'No documents selected'
    : selectedDocuments.length === 1
      ? '1 document selected'
      : `${selectedDocuments.length} documents selected`;

  return <h3 className={cn('text-grey-900 text-xl', className)}>{summaryText}</h3>;
};

export default DocumentSelectionSummary;
